export default {
  state: {
    token: localStorage.getItem('token') || '',
    user: localStorage.getItem('token') ? JSON.parse(atob(localStorage.getItem('token').split('.')[1])).user : {} || {},
    permisos: localStorage.getItem('permisos')? JSON.parse(localStorage.getItem('permisos')) : [] || [],
    auth_request: false
  },
  getters: {
    isAuthenticated: state => !!state.token,
    auth_request: state => state.auth_request,
    token: state => state.token,
    user: state => JSON.parse(atob(state.token.split('.')[1])).user || {}
  },
  mutations: {
    AUTH_REQUEST: (state, payload) => state.auth_request = payload,
    AUTH: (state, payload) => state.isAuthenticated = payload,
    SET_USER: (state, payload) => state.user = payload,
    AUTH_SUCCESS: (state, payload) => state.token = payload,
    PERMISOS: (state, payload) => state.permisos = payload
  },
  actions: {
    login({
      commit
    }, user) {
      return new Promise((resolve, reject) => {
        commit('AUTH_REQUEST', true)
        this.state.api.post('login', user)
          .then(response => {
            commit('AUTH', true);
            const token = response.data.access_token
            commit('SET_USER', JSON.parse(atob(token.split('.')[1])).user)
            localStorage.setItem('token', token)
            commit('PERMISOS', response.data.permisos)
            localStorage.setItem('permisos', JSON.stringify(response.data.permisos))
            this.state.api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            commit('AUTH_SUCCESS', token)
            resolve(response)
          }).catch(err => {
            localStorage.removeItem('token')
            reject(err)
          })
          .then(() => {
            commit('AUTH_REQUEST', false)
          })
      })
    },
    logout({
      commit
    }) {
      return new Promise((resolve) => {
        commit('AUTH', false);
        commit('SET_USER', null)
        localStorage.clear()
        delete this.state.api.defaults.headers.common['Authorization']
        resolve()
      })
    },
    me({
      commit
    }, payload) {
      this.dispatch('index', payload)
        .then()
        .catch()
    }
  }
}